<template>
  <div class="is-fullheight is-flex items-center justify-center section">

    <div class="columns is-centered is-100vw">

      <div class="column is-4">

        <div class="mb-6">

          <h3 v-if="logoText" :class="`title is-3 has-text-centered`">{{logoText}}</h3>

          <b-image v-else :src="logoImageSrc" />

        </div>

        <login-sign-up login-first @userUpdated="$emit('userUpdated', $event)" />

      </div>

    </div>

  </div>
</template>

<script>
import LoginSignUp from '@/components/LoginSignUp';

export default {
  components: {
    LoginSignUp
  },
  data() {
    return {
      logoText: process.env.VUE_APP_LOGO_TEXT,
      logoImageSrc: process.env.VUE_APP_LOGO_LOGIN || '/images/logo.png'
    }
  }
}
</script>

<style>
  .is-100vw {
    min-width: 100vw;
  }

  .is-fullheight {
    min-height: 100vh;
  }

  .items-center {
    align-items: center;
  }

  .justify-center {
    justify-content: center;
  }
</style>